import { render } from "./CheckContent.vue?vue&type=template&id=64c8095a&scoped=true"
import script from "./CheckContent.vue?vue&type=script&lang=js"
export * from "./CheckContent.vue?vue&type=script&lang=js"

import "./CheckContent.vue?vue&type=style&index=0&id=64c8095a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c8095a"]])

export default __exports__